import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { onlineStatusAtom } from '../utils/Global';

export type OnlineStatusContextType = 'offline' | 'offlineNotInit' | 'online';

export const OnlineStatusProvider: React.FC = () => {
    const setOnlineStatus = useSetAtom(onlineStatusAtom);

    useEffect(() => {
        window.addEventListener('offline', () => {
            setOnlineStatus('offline');
        });
        window.addEventListener('online', () => {
            setOnlineStatus('online');
        });

        return () => {
            window.removeEventListener('offline', () => {
                setOnlineStatus('offline');
            });
            window.removeEventListener('online', () => {
                setOnlineStatus('online');
            });
        };
    }, [setOnlineStatus]);

    return null;
};
